import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { formatDisplayDate, formatDisplayDateTime2, removeTime } from '@/utils/date'
import clone from 'clone'
import { formatPrice } from '@/utils/index'
import { extractMenu } from '@/utils/extract'

export const journalAjaxMixin = {
  data() {
    return {
      actionName: '',
      journalMenuLink: {}
    }
  },
  methods: {
    async performSearch() {
      var thisPage = this
      var blankValue = true
      Object.keys(this.filter).forEach(function(key, index) {
        if (thisPage.filter[key] !== '') {
          blankValue = false
          return false
        }
      })
      const apiUrl = this.$store.state.journal.menu.performSearch
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          const paramMap = {
            page: page - 1,
            size: itemsPerPage
          }
          let messageFilters = clone(this.filter)

          if (messageFilters.date !== '') {
            messageFilters.date = formatDisplayDateTime2(removeTime(messageFilters.date))
          }

          if (blankValue) {
            messageFilters.status = 'IP'
          }

          const result = await this.$http.get(filterQuery(expandURI(apiUrl, paramMap), messageFilters, this.pagination.sortBy, this.pagination.sortDesc))
          const { data } = result.data
          if (data) {
            this.totalItems = result.data.totalElements
            this.items = []
            data.map((result) => {
              const resultList = {
                jrnlNo: result.jrnlNo,
                date: formatDisplayDate(result.date),
                curr: result.curr,
                amount: result.amount,
                reason: result.reason,
                status: result.status,
                statusDesc: this.displayDesc(result.status)
              }
              this.items.push(resultList)
            })
          } else {
            this.items = []
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        } finally {
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
        this.loading = false
      }
    },
    displayDesc(data) {
      var desc = ''
      if (data === 'IP') {
        desc = 'In Progress'
      } else if (data === 'RJ') {
        desc = 'Rejected'
      } else if (data === 'WA') {
        desc = 'Waiting for Approval'
      } else if (data === 'AP') {
        desc = 'Approved'
      }
      return desc
    },
    getGlAdjDetList() {
      const apiURI = this.$store.state.journal.menu.glAdjDetList
      if (apiURI) {
        this.loading = true
        const expand = {
          jrnlNo: this.journalId.jrnlNo
        }
        this.$http.get(expandURI(apiURI, expand)).then(result => {
          this.glDetItems = []
          const { data } = result.data
          if (data) {
            data.map(glAdjDet => {
              const convertList = {
                branch: glAdjDet.branch,
                glAcctNo: glAdjDet.glAcctNo,
                fund: glAdjDet.fund,
                suffix: glAdjDet.suffix,
                desc: glAdjDet.desc,
                curr: glAdjDet.curr,
                adj: glAdjDet.adjustment,
                local: glAdjDet.local,
                rate: glAdjDet.rate,
                rateAE: glAdjDet.rateAE
              }
              this.glDetItems.push(convertList)
            })
          }
          this.loading = false
        }).catch(err => {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        })
      }
    },
    async performSave() {
      const apiURI = this.$store.state.journal.menu.performAction
      if (apiURI) {
        try {
          let messageFilters = clone(this.journalForm)
          if (messageFilters.tranDate !== '') {
            messageFilters.tranDate = formatDisplayDate(messageFilters.tranDate)
          }
          const result = await this.$http.post(apiURI, messageFilters)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'journalTransaction' })
          }
          this.doExit()
        } catch (err) {
          const { data } = err.response
          this.showPromptLeave = true
          if (data) {
            this.processingFlag = false
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.showPromptLeave = true
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async performReview() {
      const apiURI = this.$store.state.journal.menu.performAction
      if (apiURI) {
        try {
          this.journalForm.actionName = 'JOURNAL_REVIEW'
          const response = await this.$http.post(apiURI, this.journalForm)
          const { data } = response.data
          if (data) {
            this.journalForm.tranDate = data.journal.date
            this.journalForm.accountingPeriodAE = data.journal.accountingPerAE === 'true'
            this.journalForm.accountingMth = data.journal.accountingMth
            this.journalForm.accountingYr = data.journal.accountingYr
            this.journalForm.curr = data.journal.curr
            this.journalForm.exchangeRate = data.journal.exchangeRate
            this.journalForm.totalAdj = formatPrice(data.journal.amount)
            this.journalForm.localAdj = formatPrice(data.journal.localAmount)
            this.journalForm.exchangeRateAE = data.journal.exchangeRateAE === 'true'
            this.journalForm.reasonAdj = data.journal.reason
            this.journalForm.status = data.journal.status
            this.journalForm.createdBy = data.createdBy
            this.journalForm.createdDate = formatDisplayDate(data.createdDate)
            this.journalForm.modifiedBy = data.modifiedBy
            this.journalForm.modifiedDate = formatDisplayDate(data.modifiedDate)
            this.journalForm.statusBy = data.statusBy
            this.journalForm.statusDate = formatDisplayDate(data.statusDate)
          }
          return true
        } catch (err) {
          const { data } = err.response
          this.showPromptLeave = true
          if (data) {
            this.processingFlag = false
            this.message(data)
            this.fieldMessage(data)
          }
          return false
        }
      } else {
        this.showPromptLeave = true
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
        return false
      }
    },
    async getAcctJournalMenuLink() {
      try {
        const apiURI = this.acctMenu.acctJournal
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.journalMenuLink = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    async doExportAcctJournlReport() {
      const apiURI = this.journalMenuLink.exportSelectedJournal
      /* const jrnlForm = {
        glAcctNoBranch: this.filter.glAcctNoBranch,
        glAcctNo: this.filter.glAcctNo,
        glAcctNoFund: this.filter.glAcctNoFund,
        glAcctNoSuffix: this.filter.glAcctNoSuffix,
        jrnlNo: this.filter.jrnlNo,
        date: formatDisplayDateTime2(removeTime(this.filter.date)),
        curr: this.filter.curr,
        adjAmount: this.filter.adjAmount,
        reason: this.filter.reason,
        status: this.filter.status
      }
      */
      let messageFilters = clone(this.filter)
      if (messageFilters.date !== '') {
        messageFilters.date = formatDisplayDateTime2(removeTime(messageFilters.date))
      }

      if (apiURI) {
        this.$http.post(apiURI, messageFilters).then(result => {
        }).catch(err => {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        })
      } else {
        this.$toast.error('An error encountered unable to print Selected Journal Report.')
      }
    },
    async doExportAcctJournlRecord() {
      const apiURI = this.journalMenuLink.exportJournalRecord
      let messageFilters = clone(this.journalForm)
      if (messageFilters.tranDate !== '') {
        messageFilters.date = formatDisplayDateTime2(removeTime(messageFilters.date))
      }
      if (apiURI) {
        this.$http.post(apiURI, messageFilters).then(result => {
        }).catch(err => {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        })
      } else {
        this.$toast.error('An error encountered unable to print Journal record.')
      }
    }
  },
  computed: {
    acctMenu() {
      return this.$store.state.reports.acctReports.menu
    }
  },
  mixins: [
    MessageMixin
  ]
}
